import { formatDate } from '@angular/common';
import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Constants } from '../../../constants/ebtq-constants';
import { TransactionWrapper } from '../../../model/transactionWrapper';
import { ApiService } from '../../../services/api.service';

import { CommonUtils } from '../../../services/common-utils';
import { ErrorService } from '../../../shared/error-page/service/error-service';
import { statCd } from '../../../services/statcd-enum';
import { submissionType } from '../../../services/submissiontype-enum';
import { UtilityService } from '../../../services/utility-service';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'view-transmission',
  templateUrl: './view-transmission.component.html',
  styleUrls: ['./view-transmission.component.scss']
})

export class ViewTransmissionComponent implements OnInit {
  userId: string = null;
  month: string = null;
  date: string = null;
  containsError = false;
  errorMsg: string;
  months = [];
  showResult = false;
  warningMessage: string;
  transactionWrapper: TransactionWrapper;
  cols: any[];
  transmissionDetails: any[];
  isExternal = false;
  servicerListStr: string = null;
  errorMessage: string[] = [];
  pageView: any[];
  selectedPageView: string[];
  title = 'View Transmission Status List';

  constructor(private commonUtils: CommonUtils,
              private apiService: ApiService,
              private errorService: ErrorService,
              private router: Router,
              private utilService: UtilityService,
              private titleService: Title,
              private activatedRoute: ActivatedRoute,
              private cdr: ChangeDetectorRef) {
    this.months = this.commonUtils.lastFourMonths();
    this.month = this.months[0].value;

    this.pageView = [];
    this.pageView.push({label: 'Printable View', value: 'printView'});
    this.pageView.push({label: 'Download To Excel', value: 'downloadtoExcel'});
    this.selectedPageView = ['printView'];
  }


  public pageViewAction(event: any) {
    if (this.selectedPageView.toString() === 'downloadtoExcel') {
      event.exportCSV();
    }
    if (this.selectedPageView.toString() === 'printView') {
      const printDetailsMap = new Map();
      printDetailsMap.set('title', 'View Transmission Status List');
      printDetailsMap.set('columns', event.columns);
      printDetailsMap.set('data', this.transmissionDetails);

      this.utilService.printViewData(printDetailsMap);

      //passing the fetched results to the route results to avoid additional network call on cancel
      this.router.navigate(['print'], {
        queryParams: {
          transmissionDetails: btoa(JSON.stringify(this.transmissionDetails)),
          date:this.date,
          userId:this.userId,
          month:this.month,
          prevRoute:'viewtransmission'
        }
      });
    }

    document.getElementById('cdx-ui-patterns-header-navbar-collapse').style.display = 'inline';

  }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');
    this.cols = [
      {field: 'trkgID', header: 'View Transmission Status List Tracking ID', width: '125px'},
      {field: 'submtDt', header: 'Submission Date', width: '75px'},
      {field: 'fileNme', header: 'File Name', width: '125px'},
      {field: 'submissionType', header: 'Submission Type', width: '125px'},
      {field: 'statCd', header: 'Submission Status', width: '125px'},
      {field: 'totReqstCnt', header: 'Number of Transactions Processed', width: '125px'},
      {field: 'successCnt', header: 'Success Count', width: '125px'},
      {field: 'lastUpdUsrID', header: 'Last Updated UID', width: '125px'}
    ];
    this.warningMessage = '';

    // get the list of authorized servicers 5 digits
    this.getServicerList();
    //retrieving the previous route results to avoid additional network call on cancel
    this.activatedRoute.queryParams.subscribe(params => {

      if (params.transmissionDetails !== undefined && params.transmissionDetails.length !== 0) {
        this.transmissionDetails = JSON.parse(atob(params.transmissionDetails));
        this.showResult = true;
      }
      if (params.date !== undefined) {
        this.date = params.date;
      }
      if (params.userId !== undefined) {
        this.userId = params.userId;
      }
      if (params.month !== undefined) {
        this.month = params.month;
      }
      this.cdr.detectChanges();
    });

  }

  private getServicerList() {
    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.isExternal = (this.isExternal == null) ? false : this.isExternal;

    if (this.isExternal) {
      const authServicerNumbersArr = JSON.parse(sessionStorage.getItem('authServicerNumbersArr'));
      if (authServicerNumbersArr != null) {
        const firstServicerNumber = authServicerNumbersArr[0];
        this.servicerListStr = ' (' + firstServicerNumber.slice(0, 5);
        for (const servicerNumber of authServicerNumbersArr) {
          const servicerNo5Digit = servicerNumber.slice(0, 5);

          if (this.servicerListStr.indexOf(servicerNo5Digit) === -1) {
            this.servicerListStr = this.servicerListStr + ',' + servicerNo5Digit;
          }
        }

        this.servicerListStr = this.servicerListStr + ')';
      }
    }
  }

  transmissionListSearch() {
    this.warningMessage = '';
    this.errorMessage = [];
    this.showResult = false;


    /** User ID  Validation */
    const userID = this.userId;
    if (userID !== '' && userID != null) {
      if (this.utilService.isContainIllegalChar(userID) === true) {
        this.errorMessage.push(Constants.USERID_SEARCH_VALIDATION);
        return;
      }
    }

    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.parameters[0] = this.month;
    if (this.date == null) {
      transactionWrapper.parameters[1] = this.date;
    } else {
      const formattedDt = formatDate(this.date, 'MM/dd/yyyy', 'en_US');
      transactionWrapper.parameters[1] = formattedDt;
    }
    transactionWrapper.parameters[2] = this.userId;
    transactionWrapper.parameters[3] = this.servicerListStr;
    transactionWrapper.queryServiceName = Constants.TRANSMISSION_KEY_LIST;
    this.apiService.executeQuery(transactionWrapper).subscribe(
      (data: any) => {
        if (data != null) {
          const values = [];
          //Obj is List of Transmission list
          const obj = Object.values(data)[6];
          if (obj == null || obj === 0) {
            this.warningMessage = Constants.No_DATA_FOUND;
            this.cdr.detectChanges();
            return;
          }
          if (obj != null && Object.entries(obj).length > 500) {
            this.warningMessage = Constants.RESULT_WARNING;
            this.cdr.detectChanges();
            return;
          }
          //Retriving List of Bjects From Data And Conveting SubmissionType and Status
          //from Code to Decoder
          for (const [key, value] of Object.entries(obj)) {
            value.submissionType = submissionType[value.submissionType];
            value.statCd = statCd[value.statCd];
            values[key] = value;
          }
          if (values.length > 0) {
            this.showResult = true;
            this.transmissionDetails = values;
          }
          this.cdr.detectChanges();
        }
      },
      error => {
        this.errorService.announceError(error);
        this.cdr.detectChanges();
      }
    );
    this.errorAnnouncement();
  }
  errorAnnouncement() {
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  // Method for on key enter submit
  trackKeyPress(e) {
    if (e.keyCode === 13)
    {this.transmissionListSearch();}
  }

}
